<template>
  <v-combobox v-model="selectedValue" :items="availableItems" :hide-no-data="!search" :search-input.sync="search"
    small-chips multiple outlined dense hide-details
    :label="label !== null && label !== undefined ? label : $t('message.tags')" @input="onInput">
    <template slot="no-data">
      <v-list-item v-if="search">
        <span class="subheading">{{ $t('message.click_enter_add_new') }}: </span>
        <v-chip label small class="ml-2">
          {{ search }}
        </v-chip>
      </v-list-item>
    </template>
  </v-combobox>
</template>

<script>
import Api from "@/services/Api";

export default {
  name: 'TagsCombo',
  props: {
    label: String,
    items: {
      type: Array,
      default: () => []
    },
    // Vue 2 v-model uses the 'value' prop by default
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // Initialize internal value from the prop for immediate pre-selection
      selectedValue: this.value || [],
      availableItems: [],
      search: null,
      loading: false
    };
  },
  watch: {
    // Watch for external changes to member.tags (e.g., after an API load in parent)
    value(newVal) {
      this.selectedValue = newVal;
    },
    // Watch for items passed as props
    items: {
      immediate: true,
      handler(newItems) {
        if (newItems && newItems.length) {
          this.availableItems = [...newItems];
        } else {
          this.getAvailableTags();
        }
      }
    }
  },
  methods: {
    onInput(val) {
      // Emit 'input' to update the parent's v-model AND trigger @input="updateTags"
      this.$emit('input', val);
    },
    getAvailableTags() {
      if (this.loading) return;
      this.loading = true;

      Api()
        .get("admins/academy/" + this.$store.state.selectedAcademy + "/tags")
        .then((response) => {
          if (response.data) {
            // FIXED: You were assigning to 'availableTags' instead of 'availableItems'
            this.availableItems = response.data.sort();
          }
        })
        .catch((e) => {
          console.error("Tags fetch error:", e);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>